// extracted by mini-css-extract-plugin
export default {"section":"BudgetChangeSummary_section__95VOR","line":"BudgetChangeSummary_line__drDOW"};